export const SET_REGISTRATION = "SET_REGISTRATION";
export const SET_UPDATE_EXISTS = "SET_UPDATE_EXISTS";
